<div class="field-group"
     [class.origami-updated]="isUpdatedByOrigami"
>
  <p-iftalabel class="w-full">
    @if (control(); as ctrl) {
      <p-multiselect
        class="w-full"
        [attr.data-test]="dataTest()"
        [dataKey]="dataKey()"
        [filter]="filter()"
        [formControl]="ctrl"
        [id]="inputId()"
        [maxSelectedLabels]="maxSelectedLabels()"
        [optionLabel]="optionLabel()"
        [options]="options()"
        [placeholder]="placeholder()"
        (onChange)="modelChange.emit($event.value)"
        (onFilter)="filterEvent.emit($event)"
      />
    }

    <label class="block font-medium mb-1"
           [for]="inputId()"
    >
      {{ label() }}
    </label>
  </p-iftalabel>
  @if (showRequiredHint) {
    <small class="block text-red-500 text-xs mt-1">{{ label() }} is required.</small>
  }
</div>
